/**
 * Payment-related enums, trimmed to only what the payments feature needs.
 * (Copied/adapted from the ZIM-Portal @zim-portal/enums library.)
 */

export enum EFeeType {
  WALLET_FEE = 'WALLET_FEE',
}

export enum EStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

/** Payment channels understood by the backend gateway. */
export enum EPaymentChannel {
  IVERI = 'IVERI',
  CBZ = 'CBZ',
  ECOCASH = 'ECOCASH',
  ZIMSWITCH = 'ZIMSWITCH',
  ZIM_SWITCH = 'ZIM_SWITCH',
}

/** The payment method a user can pick on the checkout screen. */
export type PaymentMethod = 'MASTERCARD' | 'ZIMSWITCH' | 'ECOCASH' | null;
